
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CollaboratorService } from "@/services/timetrack/CollaboratorService"
import Collaborator, { CollaborationState } from "@/types/collaborator/Collaborator"
import ConfirmDialog from "@/components/ConfirmDialog.vue"

@Component({
  filters: {
    formatCurrency (value: any) {
      return Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR'
      }).format(value)
    }
  },
  components: {
    ConfirmDialog
  }
})
export default class CollaboratorTable extends Vue {
  @Prop({ required: true })
  private projectId!: string

  private loading = false
  private confirmDisableDialog = false
  private confirmDeleteDialog = false
  private confirmResendDialog = false
  private selectedItem: Collaborator | null = null
  private collaborators: Collaborator[] | null = null

  private collabHeaders = [
    { text: this.$t('timetrack.collab.mail'), value: 'collaboratorMail', sortable: true },
    { text: this.$t('timetrack.collab.state.title'), value: 'state', sortable: true },
    { text: this.$t('timetrack.collab.salary'), value: 'collaboratorSalary', sortable: false },
    { text: this.$t('timetrack.collab.actions'), value: 'actions', align: 'center' }
  ]

  private collaboratorService = new CollaboratorService()

  created () {
    this.fetchCollaborations()
    this.initEventListeners()
  }

  private initEventListeners () {
    this.$root.$on('update', this.fetchCollaborations)
  }

  private handleCollaboratorClicked (collaborator: Collaborator) {
    this.$emit('updateCollaborator', collaborator)
  }

  private fetchCollaborations () {
    if (!this.projectId) return
    this.loading = true
    this.collaboratorService.getCollaboratorsForProject(this.projectId)
      .then((collaborators) => {
        this.collaborators = collaborators
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }

  private handleDisableButtonClicked () {
    if (!this.selectedItem || !this.selectedItem.id) return
    this.loading = true
    this.collaboratorService.setCollaboratorState(this.selectedItem.id, CollaborationState.disable)
      .then(() => {
        this.fetchCollaborations()
        this.confirmDisableDialog = false
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }

  private reactivateProjectForUser () {
    if (!this.selectedItem || !this.selectedItem.id) return
    this.loading = true
    this.collaboratorService.setCollaboratorState(this.selectedItem.id, CollaborationState.reactivated)
      .then(() => {
        this.fetchCollaborations()
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }

  private handleResendButtonClicked () {
    if (!this.selectedItem || !this.selectedItem.id) return
    this.loading = true
    this.collaboratorService.setCollaboratorState(this.selectedItem.id, CollaborationState.invited)
      .then(() => {
        this.fetchCollaborations()
        this.confirmResendDialog = false
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }

  private handleDeleteButtonClicked () {
    if (!this.selectedItem || !this.selectedItem.id) return
    this.loading = true
    this.collaboratorService.setCollaboratorState(this.selectedItem.id, CollaborationState.delete)
      .then(() => {
        this.fetchCollaborations()
        this.confirmDeleteDialog = false
      }).catch((error) => {
        this.$store.dispatch('error/setError', error)
      }).finally(() => {
        this.loading = false
      })
  }
}
